import { useEffect, useState } from 'react';

import { fetchExercise } from './exerciseApi';
import type { ExerciseData } from './exerciseTypes';

export function useExerciseData(exerciseId: string) {
  const [exercise, setExercise] = useState<ExerciseData | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let ignore = false;

    async function loadExercise() {
      try {
        setIsLoading(true);
        setError(null);
        const result = await fetchExercise(exerciseId);
        if (!ignore) {
          setExercise(result as ExerciseData);
        }
      } catch (loadError) {
        if (!ignore) {
          setError(loadError instanceof Error ? loadError.message : 'Unable to load exercise.');
        }
      } finally {
        if (!ignore) {
          setIsLoading(false);
        }
      }
    }

    void loadExercise();
    return () => {
      ignore = true;
    };
  }, [exerciseId]);

  return { exercise, isLoading, error };
}
